import { render } from "./ZNclasswide.vue?vue&type=template&id=13f7eb5a&scoped=true"
import script from "./ZNclasswide.vue?vue&type=script&lang=js"
export * from "./ZNclasswide.vue?vue&type=script&lang=js"

import "./ZNclasswide.vue?vue&type=style&index=0&id=13f7eb5a&lang=scss&scoped=true"
import "./ZNclasswide.vue?vue&type=style&index=1&id=13f7eb5a&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f7eb5a"]])

export default __exports__